import Pager from '@/shared/pager/pager';

export default {
  build: () => {
    const keysToSearch = [
      'name',
    ];

    const exportDefinitions = [
      { value: 'id', label: 'id' },
      { value: 'name', label: 'name' }
      // { value: 'created', label: 'Created at' },
      // { value: 'modified', label: 'Updated at' }
    ];

    return new Pager(keysToSearch, exportDefinitions);
  }
};



// WEBPACK FOOTER //
// ./src/entities/category/category-pager.js